import { RadioButton } from "components/common/RadioButton";
import { renderModal } from "components/common/renderModal";
import { HasChildren } from "util/enhancer";
import { Nullable } from "util/extendedTypes";
import { AssertionsModal } from "./AssertionsModal";

export type AssertionQuestionProps = {
  name: string;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  value: Nullable<boolean>;
  confirmValue?: boolean;
  yesLabel?: string;
  noLabel?: string;
} & HasChildren;

export const AssertionQuestion = (props: AssertionQuestionProps) => {
  const yes = props.value === true;
  const no = props.value === false;
  const confirmModal = (optionLabel: string) =>
    renderModal<boolean>(({ open, onCloseRequest, onSubmit }) => (
      <AssertionsModal
        open={open}
        onCloseRequest={onCloseRequest}
        onConfirm={() => onSubmit(true)}
        optionLabel={optionLabel}
      />
    ));

  const changeHandler = async (b: boolean, optionLabel: string) => {
    if (props.confirmValue === b) {
      try {
        const res = await confirmModal(optionLabel);
        if (res) props.onChange(b);
      } catch (error) {
        console.log(error);
      }
    } else {
      props.onChange(b);
    }
  };

  return (
    <fieldset>
      {props.children}
      <RadioButton
        name={props.name}
        label={props.yesLabel ?? "Yes"}
        isSelected={yes}
        onChange={() => changeHandler(true, "Yes")}
        disabled={props.disabled}
      />
      <RadioButton
        name={props.name}
        label={props.noLabel ?? "No"}
        isSelected={no}
        onChange={() => changeHandler(false, "No")}
        disabled={props.disabled}
      />
    </fieldset>
  );
};
